import { useTabLabels } from '@/hooks/useTabLabels';
import { NoDataIcon } from '@/icons/index';

import ParentMapContent from './ParentMapContent';

interface DescriptionTabProps {
	courseDescription?: string;
	courseExtras?: string;
	coursePrereq?: string;
}

const isEmptyHtml = (val: string | undefined | null): boolean => {
	if (!val) return true;
	const stripped = val.replace(/<[^>]*>/g, '').trim();
	return stripped.length === 0;
};

const DescriptionTab = ({ courseDescription, courseExtras, coursePrereq }: DescriptionTabProps) => {
	const labels = useTabLabels();
	const contentArr = [courseDescription, courseExtras, coursePrereq];
	const isEmpty = contentArr.every(isEmptyHtml);

	if (isEmpty) {
		return (
			<div className="panel-content">
				<NoDataIcon message="This course does not have a listed description." delay={0} />
			</div>
		);
	}

	return (
		<>
			<ParentMapContent content={courseDescription} />
			<ParentMapContent content={coursePrereq} header={labels.prereq} />
			<ParentMapContent content={courseExtras} header={labels.extraInfo} />
		</>
	);
};

export default DescriptionTab;
